export const getProductsAndAddons = (products) =>
	products.reduce((allProducts, product) => {
		const addons = Object.values(product.selectedAddOns ?? []);

		// Always add the product itself to the list of products.
		allProducts.push(product);

		// If there are addons, add them to the list of products.
		if (addons.length > 0) {
			allProducts.push(
				...addons
					.filter(({ added }) => added)
					.map((el) => ({ ...el, isAddOn: true })),
			);
		}

		return allProducts;
	}, []);
